import { Fragment } from 'react';
import { useNavigate } from 'react-router';

import { createIncident } from '@ngsos/portal-core/commands';
import { resolveIncidentForCall } from '@ngsos/portal-core/incidents';

import { incidentDetailRoute } from '@/features/shared/routes';
import type { Incident, PortalCall } from '@/signalr/contracts';

import { CallNotificationListComponentItem } from './CallNotificationListComponentItem';
import { IncidentCreationFeedback } from './IncidentCreationFeedback';
import { useCreateIncident } from './useCreateIncident';

export type CallNotificationListComponentProps = {
  callNotifications: readonly PortalCall[];
  incidents: readonly Incident[];
};

export function CallNotificationListComponent({ callNotifications, incidents }: CallNotificationListComponentProps) {
  const navigate = useNavigate();
  const creation = useCreateIncident();

  const createNewIncident = async (call: PortalCall) => {
    const incidentId = await creation.create({
      key: call.id,
      execute: (id) => createIncident(id, [call.callerPhoneNumber]),
    });
    if (incidentId !== null) await navigate(incidentDetailRoute(incidentId));
  };

  return (
    <div className="call-notifications-list">
      {callNotifications.map((call) => (
        <Fragment key={call.id}>
          <IncidentCreationFeedback status={creation.statusFor(call.id)} compact />
          <CallNotificationListComponentItem
            call={call}
            disabled={creation.pending}
            incidentId={resolveIncidentForCall(call, incidents)?.incidentId ?? null}
            onCreateNewIncident={createNewIncident}
          />
        </Fragment>
      ))}
    </div>
  );
}
